<script>
    import Icon from 'svg/card_diners_club.svg'
    export default {
        components: {
            Icon
        },
        template: '<Icon></Icon>'
    }
</script> 